import { Moment } from "moment";
import Utils from "../utils";
import { SyncModel, SyncDataModel, DataModel } from "./syncModel";
import { ApiResponseData } from "../../services/YourAppServer/YourAppServerApi.service";
import { BonusLocationViewModel } from "./location.model";
import { InternationalisationService } from "../../forked/angular-internationalisation";

/** Art der Sammlung von Bonus Punkten */
export enum BonusType {
  None = 0,
  Product = 1,
  Visit = 2
}

/** Art der Einlösung der Bonus Punkte */
export enum BenefitType {
  None = 0,
  Product = 1
}

export enum BonusPointsLoadState {
  NotLoaded = 'not_loaded',
  Loading = 'loading',
  Success = 'success',
  Error = 'error',
  NotAvailable = 'not_available'  // für nicht registrierte Benutzer
}

export class BonusActionViewModel {
  public id: number;
  public labelDE: string;
  public descriptionDE: string;
  public descriptionEN: string;
  public get description(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.descriptionEN) ? this.descriptionDE : this.descriptionEN;
  }
  public image_photo: string;
  public like: boolean;
  public points: number;
  public locationsParticipated: boolean;
  public targetLocationIds: number[];
  public locations: BonusLocationViewModel[];
  public benefits: BonusactionBenefitViewModel[];
  /** Points loading state */
  public pointsLoadState: BonusPointsLoadState;
  /** Check if points are successfully loaded and valid */
  public get hasValidPoints(): boolean {
    return this.pointsLoadState === BonusPointsLoadState.Success;
  }
  /** Check if points loading failed */
  public get hasPointsLoadingError(): boolean {
    return this.pointsLoadState === BonusPointsLoadState.Error;
  }
  /** points for the benefit product in the basket */
  public pointsInBasket: number;
}

export class BonusactionDetailViewModel {
  public id: number;
  public labelDE: string;
  public descriptionDE: string;
  public descriptionEN: string;
  public get description(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.descriptionEN) ? this.descriptionDE : this.descriptionEN;
  }
  public startDateYMD: string;
  public endDateYMD: string;
  public image_photo: string;
  public like: boolean;
  public points: number;
  /** Points loading state */
  public pointsLoadState: BonusPointsLoadState;
  /** Check if points are successfully loaded and valid */
  public get hasValidPoints(): boolean {
    return this.pointsLoadState === BonusPointsLoadState.Success;
  }
  /** Check if points loading failed */
  public get hasPointsLoadingError(): boolean {
    return this.pointsLoadState === BonusPointsLoadState.Error;
  }
  /** points for the benefit product in the basket */
  public pointsInBasket: number;
  public locations: BonusLocationViewModel[];
  public rate: number;
  public showBenefitText: boolean;
  public benefits: BonusactionBenefitViewModel[];
  public benefitText: string;
  public storageDate: string;
  public hasEnd: boolean;
}

export class BonusPointsViewModel {
  public hasData: boolean;
  public errorCode: BonuspointsErrorNumber;
  public errorMessage: string;
  public using: boolean;
  public lastPointAction: string;
  public actions: BonuspointsAction[];
  public storageDate: Moment;
}

export class BonusactionBenefitViewModel {
  public id: number;
  public bonusaction_id: number;
  public product_id: number;
  public loss_id: number;
  public label_de: string;
  public cost: number;
  public benefitpercantage: number;
  public image_photo: string;
  public isInBasket: boolean;
  public canRedeemOnline: boolean;
}

export class BonuspointsActionBenefit {
  public label_de: string;
  public product_id: number;
  public loss_id: number;
  public points: number;
  public end_day_ymd: number;
  public get has_end_day() {
    return this.end_day_ymd > Utils.MinYMD;
  }
  public get end_day() {
    return Utils.GetMomentFromInt(this.end_day_ymd);
  }
}

export class BonuspointsAction {
  public id: number;
  public label_de: string;
  public points: number;
  public end_day_ymd: number;
  public get has_end_day() {
    return this.end_day_ymd > Utils.MinYMD;
  }
  public get end_day() {
    return Utils.GetMomentFromInt(this.end_day_ymd);
  }
  public benefits: BonuspointsActionBenefit[];
  public hide_benefit_on_receipt: boolean;
  public text_for_receipt: string;
}

export enum BonuspointsErrorNumber {
  None = 0, // local code for yourape, it not exists
  UnknownVersion = 50,
  WrongTTADate = 51,
  WrongCardnummber = 52,
  AccountNotFound = 54,
  ProductNotFound = 55,
  BonusactionNotFount = 56,
  MultiHeader = 60,
  NotActiveDB = 90,
  InternError = 99
}

export class BonuspointsView {
  public hasData: boolean; // true if has data, false if not loaded or error
  public errorCode: BonuspointsErrorNumber;
  public errorMessage: string;
  // paresd data from bonuspoints
  public using: boolean;
  public lastPointAction: string;
  public actions: BonuspointsAction[];
}

// Requests
export class BonusactionSettingsSyncModel extends SyncModel {
}

export class BonusactionSyncModel extends SyncModel {
}

export class BonusactionBenefitSyncModel extends SyncModel {
}

export class BonuspointsSyncModel {
  public version: number;
}

export class NewBonuspointsSyncModel {
  public version: number;
  public last_point_action: string;
}

// Responses

/** Only one settings exists and it has the id=0 (this const is used for selecting the settings) */
export const BonusactionSettingsDMKey: number = 0;

export class BonusactionSettingsDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  public id: number;
  public points_label_de: string;
  public visits_label_de: string;
  /** not used yet */
  public allow_user_regestration: boolean;
  /** not used yet */
  public data_protection_active: boolean;
  /** not used yet */
  public data_protection_de: string;
  public change_at_ymd: number;
  public change_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
  public change_by: number;
}

export class BonusactionSettingsSyncDataModel extends SyncDataModel {
  public settings: BonusactionSettingsDataModel[];
  public get models(): DataModel[] { return this.settings; }
  public DeserializeType(): void {
    this._DeserializeType(BonusactionSettingsDataModel);
  }
}

export class BonusactionDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  public id: number;
  public label_de: string;
  public description_de: string;
  public description_en: string;
  public start_at_ymd: number;
  public get start_at(): Moment {
    return Utils.GetMomentFromInt(this.start_at_ymd, 0);
  }
  public end_at_ymd: number;
  /** bonus end */
  public get has_end_at() {
    return this.end_at_ymd > Utils.MinYMD;
  }
  public get end_at(): Moment {
    return Utils.GetMomentFromInt(this.end_at_ymd, 0);
  }
  public total_end_at_ymd: number;
  /** benefit end */
  public get has_total_end_at() {
    return this.total_end_at_ymd > Utils.MinYMD;
  }
  public get total_end_at(): Moment {
    return Utils.GetMomentFromInt(this.total_end_at_ymd, 0);
  }
  public bonus_typ: BonusType;
  public benefit_typ: BenefitType;
  public hide_benefit_on_receipt: boolean;
  public text_for_receipt: string;
  public last_image_update_at_ymd: number;
  public last_image_update_at_hms: number;
  public get last_image_update_at(): Moment {
    return Utils.GetMomentFromInt(this.last_image_update_at_ymd, this.last_image_update_at_hms);
  }
  public locations_participation: boolean; // if true locations exclusive, else there are excludet
  public locations: number[]; // locations are white listed when locations_participation=true else they are blacklisted for new locations
  public deleted: boolean;
  public change_at_ymd: number;
  public change_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
  public change_by: number;
}

export class BonusactionSyncDataModel extends SyncDataModel {
  public bonusactions: BonusactionDataModel[];
  public get models(): DataModel[] { return this.bonusactions; }
  public DeserializeType(): void {
    this._DeserializeType(BonusactionDataModel);
  }
}

export class BonusactionBenefitDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  public id: number;
  /** RefID reference to main Benefit with central ArtHypCusNr (if has sub ArtHypCusNr) */
  public ref_id: number;
  public bonusaction_id: number;
  public product_id: number;
  /** HypCusNumber of the ProductID (vom Artikelstamm) */
  public art_hyp_cus_nr: number;
  /** externe item Bezeichnung */
  public label_de: string;
  /** Verlustgrund, welcher am POS verbucht wird */
  public loss_id: number;
  /** points of cost */
  public points: number;
  public register_need: boolean;
  public last_image_update_at_ymd: number;
  public last_image_update_at_hms: number;
  public get last_image_update_at(): Moment {
    return Utils.GetMomentFromInt(this.last_image_update_at_ymd, this.last_image_update_at_hms);
  }
  public deleted: boolean;
  public change_at_ymd: number;
  public change_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
  public change_by: number;
}

export class BonusactionBenefitSyncDataModel extends SyncDataModel {
  public benefits: BonusactionBenefitDataModel[];
  public get models(): DataModel[] { return this.benefits; }
  public DeserializeType(): void {
    this._DeserializeType(BonusactionBenefitDataModel);
  }
}

/** interface mit Bonusinformation zu einem Gutschein */
export interface IBonuspoints {
  /** Versionsnummer vom Aufbau des Strings bonuspoints */
  version: number;
  /** Serialiszerte Bonuspunkte (Version ist zu beachten) */
  bonuspoints: string;
}

export class BonuspointsDataModel implements ApiResponseData, IBonuspoints {
  public version: number;
  public bonuspoints: string;

  DeserializeType(): void {
    // no complex data
  }
}
